import { render, staticRenderFns } from "./DataAuthentication.vue?vue&type=template&id=bf13d85e&scoped=true&"
import script from "./DataAuthentication.vue?vue&type=script&lang=js&"
export * from "./DataAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./DataAuthentication.vue?vue&type=style&index=0&id=bf13d85e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf13d85e",
  null
  
)

export default component.exports